import React from 'react';

/**
 * Pop-up die getoond wordt zodra de kandidaat- of bedrijfsintake volledig is
 * afgerond. Bedankt de gebruiker en legt de vervolgstap uit, met een knop om
 * terug te gaan naar het dashboard.
 */
export default function IntakeCompleteModal({
  accentColor = '#3f7f65', // brand-green; bedrijven geven '#713d8d' (brand-purple) mee
  title,
  thankYouText,
  nextStepsTitle,
  nextStepsBody,
  buttonLabel,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="w-full max-w-lg animate-fade-in-up rounded-[1.4rem] border-4 border-[#151827] bg-[#fffdf8] p-8 shadow-[12px_12px_0_#151827]">
        <div className="text-center">
          <div
            className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full text-3xl text-white"
            style={{ backgroundColor: accentColor }}
          >
            ✓
          </div>
          <h2 className="text-2xl font-black text-[#151827]">{title}</h2>
          <p className="mt-3 text-gray-600">{thankYouText}</p>
        </div>

        <div className="mt-6 rounded-xl border-2 border-[#151827]/15 bg-white p-5">
          <h3 className="mb-2 text-xs font-bold uppercase tracking-wide text-[#151827]/70">{nextStepsTitle}</h3>
          <p className="text-sm leading-relaxed text-gray-700">{nextStepsBody}</p>
        </div>

        <div className="mt-7 flex justify-center">
          <button
            onClick={onClose}
            className="rounded-xl px-8 py-4 text-lg font-black text-white transition-transform hover:translate-x-0.5 hover:translate-y-0.5"
            style={{ backgroundColor: accentColor, boxShadow: '6px 6px 0 #151827' }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
